// Public newsletter signup widget — minimal, no third-party JS.
import { useState } from "react";
import api from "@/lib/api";

const TEXT = {
  fr: {
    title: "Restons en contact",
    subtitle: "Recevez nos communiqués sur les Fêtes 2027.",
    email: "Votre email",
    name: "Votre nom (optionnel)",
    submit: "M'inscrire",
    submitting: "Envoi…",
    ok: "Merci ! Vérifiez votre boîte mail pour confirmer.",
    fail: "Erreur — réessayez.",
  },
  en: {
    title: "Stay in touch",
    subtitle: "Get our updates about the 2027 Feasts.",
    email: "Your email",
    name: "Your name (optional)",
    submit: "Subscribe",
    submitting: "Sending…",
    ok: "Thank you! Check your inbox to confirm.",
    fail: "Error — please retry.",
  },
};

export default function NewsletterSignup({ locale = "fr" }) {
  const t = TEXT[locale] || TEXT.fr;
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("idle"); // idle | busy | ok | fail

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    setStatus("busy");
    try {
      await api.post("/newsletter/subscribe", { email, name, locale });
      setStatus("ok");
      setEmail("");
      setName("");
    } catch {
      setStatus("fail");
    }
  };

  return (
    <div className="max-w-xl mx-auto mt-8 p-6 bg-white border" style={{ borderColor: "var(--border)" }}
         data-testid="newsletter-signup">
      <div className="text-center mb-4">
        <span className="font-caps text-[0.6rem]" style={{ color: "var(--gold)", letterSpacing: "0.22em" }}>
          ◇ {t.title} ◇
        </span>
        <p className="font-display italic mt-2" style={{ color: "var(--ink-2)" }}>
          {t.subtitle}
        </p>
      </div>
      <form onSubmit={submit} className="space-y-3">
        <input
          type="email" required
          placeholder={t.email}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="input-classic w-full"
          data-testid="newsletter-email"
        />
        <input
          type="text"
          placeholder={t.name}
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="input-classic w-full"
          data-testid="newsletter-name"
        />
        <button type="submit" disabled={status === "busy"}
                className="btn btn-primary w-full"
                data-testid="newsletter-submit">
          {status === "busy" ? t.submitting : t.submit}
        </button>
        {status === "ok" && (
          <p className="text-sm text-center" style={{ color: "var(--moss)" }} data-testid="newsletter-ok">
            ✓ {t.ok}
          </p>
        )}
        {status === "fail" && (
          <p className="text-sm text-center" style={{ color: "var(--cinnabar)" }}>
            {t.fail}
          </p>
        )}
      </form>
    </div>
  );
}
